import { Route, Routes } from 'react-router-dom';

import { CarrierPortalOrdersPage } from './orders/CarrierPortalOrders';
import { CarrierPortalOrderDetail } from './orders/CarrierPortalOrderDetail';
import { CarrierPortalPlanningPage } from './planning/CarrierPortalPlanningPage';
import CarrierPortalSelfBillingsPage from './self-billing/CarrierPortalSelfBills';
import { CarrierPortalInfoWrapper } from './information/CarrierPortalInfoWrapper';
import { CarrierPortalInfoPage } from './information/CarrierPortalInfoPage';
import { CarrierPortalInfoTruckPage } from './information/CarrierPortalInfoTruckPage';
import { CarrierPortalCreateTruckPage } from './information/CarrierPortalCreateTruckPage';
import { CarrierPortalUpdateTruckPage } from './information/CarrierPortalUpdateTruckPage';
import { CarrierPortalContactsPage } from './information/CarrierPortalContactsPage';
import { CarrierPortalCreateContactPage } from './information/CarrierPortalCreateContactPage';
import { CarrierPortalUpdateContactPage } from './information/CarrierPortalUpdateContactPage';
import { CarrierPortalMePage } from './users/CarrierPortalMe';
import { CarrierPortalUsersPage } from './users/CarrierPortalUsersPage';
import { CarrierPortalStubPage } from './CarrierPortalStubPage';
import { CarrierPortalKnowledgeBasePage } from './knowledge-base/KnowledgeBasePage';
import { CarrierPortalTrackingPage } from './tracking/CarrierPortalTrackingPage';

export const CarrierPortalRoutes = () => {
  return (
    <Routes>
      <Route path="orders">
        <Route index element={<CarrierPortalOrdersPage />} />
        <Route path=":orderId" element={<CarrierPortalOrderDetail />} />
      </Route>

      <Route path="planning">
        <Route index element={<CarrierPortalPlanningPage />} />
      </Route>

      <Route path="self-billing">
        <Route index element={<CarrierPortalSelfBillingsPage />} />
      </Route>

      <Route path="business-information" element={<CarrierPortalInfoWrapper />}>
        <Route path="info" element={<CarrierPortalInfoPage />} />
        <Route path="trucks">
          <Route index element={<CarrierPortalInfoTruckPage />} />
          <Route path="new" element={<CarrierPortalCreateTruckPage />} />
          <Route path=":carrierTruckId" element={<CarrierPortalUpdateTruckPage />} />
        </Route>
        <Route path="contacts">
          <Route index element={<CarrierPortalContactsPage />} />
          <Route path="new" element={<CarrierPortalCreateContactPage />} />
          <Route path=":contactId" element={<CarrierPortalUpdateContactPage />} />
        </Route>
      </Route>

      <Route path="knowledge-base" element={<CarrierPortalKnowledgeBasePage />} />

      <Route path="tracking" element={<CarrierPortalTrackingPage />} />

      <Route path="me" element={<CarrierPortalMePage />} />
      <Route path="users" element={<CarrierPortalUsersPage />} />
      <Route path="not-found" element={<CarrierPortalStubPage />} />
    </Routes>
  );
};
